var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentaire(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.021,
    height: 46.004,
    viewBox: "0 0 46.021 46.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_57",
    "data-name": "Groupe 57",
    transform: "translate(2175.403 -2988.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16",
    "data-name": "Trac\\xE9 16",
    d: "M-2131.944,3024.634a3.707,3.707,0,0,1,.211-3.092,22.994,22.994,0,0,0-19.609-33.027,23.094,23.094,0,0,0-24.024,23.263,14.173,14.173,0,0,0,.378,3.99A23,23,0,0,0-2142.01,3032a2.926,2.926,0,0,1,2.392-.177c2.584.794,5.177,1.561,7.765,2.345.717.217,1.43.576,2.107-.091.65-.64.25-1.308.055-1.966C-2130.429,3029.614-2131.115,3027.1-2131.944,3024.634Zm-7.889,4.547a3.1,3.1,0,0,0-2.58.217c-7.067,3.738-14.143,3.655-20.9-.587-6.775-4.254-9.909-10.651-9.6-18.619.391-10.126,9.16-18.795,19.333-19.271a20.61,20.61,0,0,1,21.507,17.328,20.5,20.5,0,0,1-2.36,13.233,2.677,2.677,0,0,0-.2,2.286c.754,2.387,1.4,4.81,2.172,7.536C-2135.049,3030.565-2137.457,3029.923-2139.833,3029.181Z",
    transform: "translate(0 0)",
    fill: "#050605"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentaire);
export default __webpack_public_path__ + "static/media/commentaire.d0090b2b71ae821d70e89b4f34f452b4.svg";
export { ForwardRef as ReactComponent };